import { render, staticRenderFns } from "./MaterialResponseAdmin.vue?vue&type=template&id=4843434c"
import script from "./MaterialResponseAdmin.vue?vue&type=script&lang=js"
export * from "./MaterialResponseAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports